module.exports = __webpack_public_path__ + "assets/delete.94c807b1.svg";